type ExecutionGradingSummary = {
    isGraded: boolean;
    isReviewed: boolean;
    reviewCount: number;
};

export type GradingStatusMeta = {
    label: 'Graded' | 'Partially Graded';
    color: string;
    backgroundColor: string;
};

export function getGradingStatusMeta(summary?: ExecutionGradingSummary | null, isDark?: boolean): GradingStatusMeta | null {
    if (!summary?.isGraded) {
        return null;
    }

    if (summary.isReviewed || summary.reviewCount > 0) {
        return {
            label: 'Graded',
            color: isDark ? '#6ee7b7' : '#166534',
            backgroundColor: 'rgba(34, 197, 94, 0.14)',
        };
    }

    return {
        label: 'Partially Graded',
        color: isDark ? '#fdba74' : '#9a3412',
        backgroundColor: 'rgba(249, 115, 22, 0.14)',
    };
}